import analytics from "@idg-data-analytics-platform/analytics";

export function analyticsContentViewed(page: string) {
  analytics({
    event: "content_viewed",
    team: "control",
    properties: {
      type: "account",
      level1: page,
    },
  });
}
